import React from "react";

const SvgComponent = props => (
  <svg
    viewBox="10 10 21.39 20.23"
    height="5em"
    style={{ margin: "0 auto" }}
    display="block"
    color="#87465b"
    {...props}
  >
    <path
      d="M21.64 20.27h.46c-.08.66-.6 1.18-1.26 1.26v-.49a.16.16 0 0 0-.32 0v.5c-.67-.07-1.2-.6-1.28-1.27h.52a.16.16 0 1 0 0-.32h-.52c.07-.68.6-1.21 1.28-1.28v.31c0 .09.07.16.16.16s.16-.07.16-.16v-.31c.67.08 1.2.61 1.26 1.28h-.46a.16.16 0 1 0 0 .32m1.23-.32h-.44a1.77 1.77 0 0 0-1.59-1.61v-.4a.16.16 0 1 0-.32 0v.4c-.86.07-1.54.76-1.61 1.61h-.4a.16.16 0 1 0 0 .32h.4c.08.85.76 1.52 1.61 1.6v.45a.16.16 0 1 0 .32 0v-.46a1.79 1.79 0 0 0 1.6-1.59h.43a.16.16 0 0 0 0-.32"
      fill="currentColor"
    />
    <path
      d="M23.47 20.27h.45a3.25 3.25 0 0 1-3.08 3.08v-.45a.16.16 0 0 0-.32 0v.45a3.25 3.25 0 0 1-3.08-3.08h.46a.16.16 0 1 0 0-.32h-.46c.08-1.66 1.42-3 3.08-3.08v.46a.16.16 0 0 0 .32 0v-.46c1.67.08 3 1.42 3.08 3.08h-.45a.16.16 0 1 0 0 .32m.77-.32a3.57 3.57 0 0 0-3.4-3.4v-.94h-.32v.94a3.57 3.57 0 0 0-3.4 3.4h-.93v.32h.93a3.57 3.57 0 0 0 3.4 3.4v.95h.32v-.94a3.57 3.57 0 0 0 3.4-3.4h.95v-.33z"
      fill="currentColor"
    />
    <path
      d="M21.64 20.27h.46c-.08.66-.6 1.18-1.26 1.26v-.49a.16.16 0 1 0-.32 0v.5c-.67-.07-1.2-.6-1.28-1.27h.52a.16.16 0 1 0 0-.32h-.52c.07-.68.6-1.21 1.28-1.28v.31a.16.16 0 1 0 .32 0v-.31c.67.08 1.2.61 1.26 1.28h-.46a.16.16 0 1 0 0 .32m1.23-.32h-.44a1.77 1.77 0 0 0-1.59-1.61v-.4a.16.16 0 1 0-.32 0v.4c-.86.07-1.54.76-1.61 1.61h-.4a.16.16 0 1 0 0 .32h.4c.08.85.76 1.52 1.61 1.6v.45a.16.16 0 1 0 .32 0v-.46a1.79 1.79 0 0 0 1.6-1.59h.43a.16.16 0 1 0 0-.32"
      fill="currentColor"
    />
  </svg>
);

export default SvgComponent;



// WEBPACK FOOTER //
// ./images/lieu.svg